import { AssetSectionDto } from '@picflow/types';
import { ScreenSizes } from 'src/app/classes/screen-sizes.class';
import { getScrollbarWidth } from 'src/app/gallery-shared/lib/get-scrollbar-width';

export const getGalleryWidth = (section: AssetSectionDto, fullWidth = false, maxWidth?: number) => {
  const scrollbarWidth = getScrollbarWidth();
  let totalWidth = section.grid_width;
  let windowWidth = window.innerWidth;
  if (fullWidth) return windowWidth;
  windowWidth -= scrollbarWidth;
  if (windowWidth < totalWidth) totalWidth = windowWidth;
  if (maxWidth) return Math.min(maxWidth, totalWidth);
  if (ScreenSizes.screenSize() === 'desktop') {
    totalWidth -= 80;
  } else {
    totalWidth -= 30;
  }
  if (maxWidth) return Math.min(maxWidth, totalWidth);
  return totalWidth;
};
